import React, { useEffect, useState } from "react";
import { Card, Col, Nav, Row, Tab, Table } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { Stepper } from "./Stepper";
import { t } from "i18next";
import { useLocation } from "react-router";
import { ProductsService } from "../../service";
import { IProducts } from "../../dto/IProducts";
import { ErrorToast, SuccessToast } from "../../../../shared/toasters/toasters";
import { ProductsListView } from "../../components/ProductsListView";
import {
  formatDate,
  getCorrectLanguage,
} from "../../../../shared/functions/Functions";
import { CustomImageHandler } from "../../../../shared/components/CustomImageHandler";
import { useDispatch, useSelector } from "react-redux";
import { IAllStates } from "../../../../store/rootReducer";
import { BlockService } from "../../../block/service";
import { EnumService } from "../../../../store/enums/enumService";
import enumsSlice from "../../../../store/enums/enumsRedux";
const generateInitialLanguages = (langs: string[]) =>
  langs.map((lang) => ({
    language: lang,
    description: false,
    intro: false,
    bullets: false,
  }));
export const StepContent = () => {
  const [products, setProducts] = useState<IProducts[]>();
  const [product, setProduct] = useState<IProducts>();
  const [currentProductBlocks, setCurrentProductBlocks] = useState([]);
  const [allBlocks, setAllBlocks] = useState([] as any);
  const { translationLanguageEnum } = useSelector(
    (state: IAllStates) => state.enums
  );
  const dispatch = useDispatch();
  const [requirements, setRequirements] = useState({
    description: false,
    intro: false,
    bullets: false,
    languages:
      translationLanguageEnum?.length > 0
        ? generateInitialLanguages(translationLanguageEnum)
        : [],
  });

  useEffect(() => {
    if (!translationLanguageEnum) return;

    setRequirements((prev) => ({
      ...prev,
      languages: generateInitialLanguages(translationLanguageEnum),
    }));
  }, [translationLanguageEnum]);

  const [contentArray, setContentArray] = useState([
    { name: "description", id: "description" },
    { name: "intro", id: "intro" },
    { name: "bullets", id: "bullets" },
  ]);
  const toggleLangField = (languageCode: string, field: string) => {
    const updated = [...requirements.languages];
    const langIndex = updated.findIndex(
      (lang) => lang.language === languageCode
    );
    if (langIndex === -1) return;

    (updated as any)[langIndex][field] = !(updated as any)[langIndex][field];

    setRequirements((prev: any) => ({
      ...prev,
      languages: updated,
    }));
  };
  const selectedProducts = JSON.parse(
    localStorage.getItem("selectedProducts") as string
  );
  const selectChangeHandler = (selectedProduct: IProducts) => {
    setProduct(selectedProduct);

    selectedProduct?.id &&
      ProductsService.getProductById(+selectedProduct?.id, "BASE_DATA")
        .then((response) => {
          if (response?.block && allBlocks?.length > 0) {
            const certain = getCertainBlocks(response?.block as any, allBlocks);
            setCurrentProductBlocks(certain as any);
            const baseFields = [
              { name: "description", id: "description" },
              { name: "intro", id: "intro" },
              { name: "bullets", id: "bullets" },
            ];
            const blocksAsFields = certain.map((block: any) => ({
              name: block.name,
              id: block.id,
            }));
            setContentArray([...baseFields, ...blocksAsFields]);
          }
        })
        .catch((error) => {
          ErrorToast(error);
        });
  };
  const transformedLanguages = requirements.languages.map((langObj: any) => {
    const blocks: number[] = [];
    const cleanedObj: any = {};
    Object.entries(langObj).forEach(([key, value]) => {
      if (!isNaN(Number(key))) {
        if (value === true) {
          blocks.push(Number(key));
        }
      } else {
        cleanedObj[key] = value;
      }
    });

    return {
      ...cleanedObj,
      blocks,
    };
  });
  const handleSubmit = (e: any) => {
    e.preventDefault();
    const filteredArray = selectedProducts?.filter(
      (item: number) => item != product?.id
    );
    console.log("🧾 Checked requirements:", {
      fromProduct: product?.id,
      toProducts: filteredArray,
      ...requirements,
      languages: transformedLanguages,
    });

    ProductsService.copyManageContent({
      fromProduct: product?.id,
      toProducts: filteredArray,
      ...requirements,
      languages: transformedLanguages,
    })
      .then((response) => {
        SuccessToast(`${t("toasts.successfully_added")}`);
      })
      .catch((error) => ErrorToast(error));
  };
  const getCertainBlocks = (block: any, listOfAllBlocks: any) => {
    const data: any[] = [];
    listOfAllBlocks?.forEach((item: any) => {
      if (block.some((a: number) => a === item.id)) {
        data.push(item);
      }
    });
    return data;
  };
  useEffect(() => {
    if (selectedProducts?.length > 1) {
      const checkedValuesAsStrings = selectedProducts.map(String);
      ProductsService.getManageProductsByIds({ ids: checkedValuesAsStrings })
        .then((response) => {
          setProducts(response);
        })
        .catch((error) => ErrorToast(error));
    } else {
      return;
    }
  }, []);

  useEffect(() => {
    BlockService.getAllBlocks({
      page: 1,
      perPage: 0,
    })
      .then((response) => {
        const { data } = response;
        setAllBlocks(data as any);
      })
      .catch((error) => ErrorToast(error));
  }, []);
  useEffect(() => {
    EnumService.getEnums().then((data) => {
      dispatch(enumsSlice.actions.setEnums(data));
    });
  }, []);

  return (
    <>
      <div className="card">
        <Helmet>
          <title>{t("manage.products_manage_content")}</title>
        </Helmet>
        <div className="">
          <Stepper step={"CONTENT"}></Stepper>
          <>
            {product?.id ? (
              <>
                <div className="mt-3">
                  <div className="card-header d-flex align-items-center justify-content-between my-0">
                    <h4 className="card-title mb-0">
                      {t("manage.selected_product")}
                    </h4>
                    <button
                      className="btn btn-secondary ms-2"
                      onClick={(e) => handleSubmit(e)}
                    >
                      {t("global_v2.copy")}
                    </button>
                  </div>

                  <div className="card-body">
                    <Table className="align-middle table-nowrap ">
                      <thead className="table-light">
                        <tr>
                          <th scope="col">{`${t("global.id")}`}</th>
                          <th scope="col">{`${t("global.aenCode")}`}</th>
                          <th scope="col">{`${t("products.product")}`}</th>
                          <th scope="col">{`${t("products.category")}`}</th>
                          <th scope="col">{`${t("products.createdAt")}`}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr key={product?.id}>
                          <td>
                            <span>#{product?.id}</span>
                          </td>
                          <td>
                            <span className="text-dark">
                              {product?.eanCode ?? "-"}
                            </span>
                          </td>
                          <td>
                            <span className="d-flex justify-content-start">
                              <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 me-3">
                                  <div className="avatar-sm bg-light rounded p-1">
                                    <CustomImageHandler
                                      path={product?.productPictures?.[0]?.path}
                                      alt="Product"
                                      classes="avatar-xs h-100 w-100"
                                    />
                                  </div>
                                </div>
                                <div className="flex-grow-1">
                                  <h5 className="fs-14 mb-1">
                                    <>{product?.title ?? "-"}</>
                                  </h5>
                                </div>
                              </div>
                            </span>
                          </td>

                          <td>
                            {(product?.category as any)?.title ??
                              "Without category"}
                          </td>
                          <td>{formatDate((product as any)?.createdAt)}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <div
                    className="row"
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <div className="col-md-12">
                      <Tab.Container
                        defaultActiveKey={requirements.languages[0]?.language}
                      >
                        <Nav variant="tabs">
                          {requirements.languages.map((lang: any) => (
                            <Nav.Item key={lang.language}>
                              <Nav.Link eventKey={lang.language}>
                                {getCorrectLanguage(lang.language, t)}
                              </Nav.Link>
                            </Nav.Item>
                          ))}
                        </Nav>
                        <Tab.Content className="mt-3">
                          {requirements.languages.map(
                            (lang: any, langIndex) => (
                              <Tab.Pane
                                eventKey={lang.language}
                                key={lang.language}
                              >
                                <div className="row">
                                  {contentArray.map((field) => (
                                    <div className="col-md-4" key={field.id}>
                                      <div className="form-check my-1">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`${lang.language}-${field.id}`}
                                          checked={lang[field.id]} // ✅
                                          onChange={() =>
                                            toggleLangField(
                                              lang.language,
                                              field.id
                                            )
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`${lang.language}-${field.id}`}
                                        >
                                          {field.id === "description" ||
                                          field.id === "intro" ||
                                          field.id === "bullets"
                                            ? t(`mapping.${field.id}`)
                                            : field.name}
                                        </label>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </Tab.Pane>
                            )
                          )}
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <p>{t("manage.no_source_product")}</p>
            )}
          </>
          <>
            <div className="card-header my-0">
              <h4 className="card-title mb-0">
                {t("manage.list_of_products")}
              </h4>
            </div>
            <div className="card-body">
              <Table className="align-middle table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>{t("global.select")}</th>
                    <th scope="col">{`${t("global.id")}`}</th>
                    <th scope="col">{`${t("global.aenCode")}`}</th>
                    <th scope="col">{`${t("products.product")}`}</th>
                    <th scope="col">{`${t("products.category")}`}</th>
                    <th scope="col">{`${t("products.createdAt")}`}</th>
                  </tr>
                </thead>
                <tbody>
                  {products?.map((product: any) => (
                    <tr key={product?.id}>
                      <td>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="format"
                          id={`flexRadioDefault${product?.id}`}
                          onChange={() => selectChangeHandler(product)}
                        />
                      </td>
                      <td>
                        <span>#{product?.id}</span>
                      </td>
                      <td>
                        <span className="text-dark">
                          {product?.eanCode ?? "-"}
                        </span>
                      </td>
                      <td>
                        <span className="d-flex justify-content-start">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 me-3">
                              <div className="avatar-sm bg-light rounded p-1">
                                <CustomImageHandler
                                  path={product?.productPictures?.[0]?.path}
                                  alt="Product"
                                  classes="avatar-xs h-100 w-100"
                                />
                              </div>
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="fs-14 mb-1">
                                <>{product?.title ?? "-"}</>
                              </h5>
                            </div>
                          </div>
                        </span>
                      </td>

                      <td>
                        {(product?.category as any)?.title ??
                          "Without category"}
                      </td>
                      <td>{formatDate(product?.createdAt)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </>
        </div>
      </div>
    </>
  );
};
